var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeaToMarket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-idea-to-market"
  }, "Idea-to-Market") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-idea-to-market"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13a4.5 4.5 0 1 1 7 0c-0.8 0.7-1.3 1.5-1.3 2.4V16H7.3v-0.6c0-0.9-0.5-1.7-1.3-2.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.5h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 20.5h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15l3-8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7l3 1-1 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7l-3-1 1 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaToMarket);
export default __webpack_public_path__ + "static/media/idea-to-market.22081aa4d90b03d3bd4018e96129eb77.svg";
export { ForwardRef as ReactComponent };